// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import clickOutside from "v-click-out";
// import "element-ui/lib/theme-chalk/index.css";
import "../theme/index.css";
import ElementUI from 'element-ui';
import App from "./App";
import router from "./router";
import "./permission";
import store from "@/store";
import jsCookie from "js-cookie";
import Vuex from "vuex";
import "@/styles/globals.scss";
import VueClipBoard from 'vue-clipboard2'
// 国际化
import i18n from "@/i18n";
import { getCodeMessage } from './i18n/codeMessageIndex';
// 全局导出组件
import exportFileBtn from '@/components/exportFileBtn/exportFileBtn.vue';
import './directives'; // 全局挂载自定义指令
import './assets/iconFont/iconfont.css'; // 全局引入iconfont
import viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(viewer,{
  defaultOptions: {
    zIndex: 9999,
    navbar:false,
    toolbar:false,
    title:false,
  }
})

Vue.use(clickOutside);
// Element UI 使用 vue-i18n 的 t 方法，实现组件库与业务文案统一切换语言
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
Vue.use(router);
Vue.use(Vuex);
Vue.use(VueClipBoard)
Vue.config.productionTip = false;
Vue.prototype.$cookie = jsCookie;
function normalizeMessageArgs(messageArgs) {
  if (messageArgs === null || messageArgs === undefined) {
    return [];
  }
  if (Array.isArray(messageArgs)) {
    return messageArgs;
  }
  if (typeof messageArgs === 'object') {
    if (typeof messageArgs.length === 'number' && messageArgs.length >= 0) {
      return Array.from(messageArgs);
    }
    const orderedKeys = Object.keys(messageArgs)
      .filter(key => /^\d+$/.test(key))
      .sort((a, b) => Number(a) - Number(b));
    if (orderedKeys.length) {
      return orderedKeys.map(key => messageArgs[key]);
    }
  }
  return [messageArgs];
}
Vue.prototype.$getCodeMessage = function(code, fallbackMessage = '') {
  const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN';
  const template = getCodeMessage(code, locale, fallbackMessage);
  const messageArgs = normalizeMessageArgs(arguments.length >= 3 ? arguments[2] : undefined);
  if (typeof template !== 'string') return template;
  if (!messageArgs.length) {
    return fallbackMessage && fallbackMessage !== template ? fallbackMessage : template;
  }
  const renderedMessage = template.replace(/\{(\d+)\}/g, (match, idxStr) => {
    const idx = Number(idxStr);
    if (Number.isNaN(idx)) return match;
    const val = messageArgs[idx];
    return val === undefined || val === null ? match : String(val);
  });
  return renderedMessage;
};
Vue.component('exportFileBtn', exportFileBtn)

const APP_ENV = import.meta.env.VITE_APP_ENV; //当前环境
console.log(APP_ENV, "APP_ENV 当前环境");

const PROD_ENV = ["pre", "prod"];
// import Vconsole from "vconsole";

if (PROD_ENV.indexOf(import.meta.env.VITE_APP_ENV) === -1) {
  // let vConsole = new Vconsole()
  // Vue.use(vConsole)
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
